import { Auth, API } from 'aws-amplify';

export async function login(username, password) {
  await Auth.signIn(username, password);
  return Auth.currentAuthenticatedUser();
}

export function logout() {
  return Auth.signOut();
}

export async function getUser() {
  if (await Auth.currentSession()) {
    return Auth.currentAuthenticatedUser();
  }
  return null;
}

export async function getMyProfile() {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', '/me');
}
